import React, { FunctionComponent } from 'react'
import { useQueries } from '../../../../../utils/hooks/useQueries'
import ObjectLineMobile from './ObjectLineMobile/ObjectLineMobile'
import ObjectLineDesktop from './ObjectLineDesktop/ObjectLineDesktop'
import { ID } from '../../../../../types/UtilityTypes'

interface ObjectLineProps {
    objectId: ID,
}

const ObjectLine: FunctionComponent<ObjectLineProps> = props => {
    const {isMobile} = useQueries()
    return isMobile ? <ObjectLineMobile {...props}/>: <ObjectLineDesktop {...props}/>
}

export default ObjectLine